// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.circulation-tickets {
  border-radius: 8px;
  background-color: #FFFFFF;
}

.circulation-tickets__header {
  display: flex;
  padding-block: 20px;
  align-items: center;
}

.circulation-tickets__header button {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: #F0F0F0;
  margin-right: 20px;
}

.circulation-tickets__titles {
  display: flex;
  gap: 96px;
}

.circulation-tickets__title {
  display: flex;
  gap: 4px;
}

.circulation-tickets__title span:first-child {
  color: #999999;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}

.circulation-tickets__title span:last-child {
  color: #323232;
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
}

@media only screen and (max-width: 767px) {
  .circulation-tickets__titles {
    flex-direction: column;
    gap: 16px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/modules/circulations/circulation-tickets/CirculationTickets.scss","webpack://./src/modules/circulations/circulation-tickets/CirculationTickets.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;ACC3B;;ADCE;EAGE,aAAa;EASd,mBAAA;EANU,mBAAI;ACGjB;;AAEA;EDDM,WAAA;EACD,YAAA;ECGH,kBAAkB;EDAlB,mBAAA;EACE,kBAAa;ACEjB;;AAEA;EDEI,aAAQ;EAgBT,SAAA;ACbH;;AAEA;EDCM,aAAa;EACb,QAAA;ACGN;;ADZG;EAYG,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;ACIvB;;ADCA;EAEI,cAAA;ECCF,eDAI;ECCJ,kBDAa;ECCb,gBDAG;ECCH,iBAAiB;AACnB;;AAEA;EACE;IAIU,sBAAsB;IAC9B,SAAS;EACX;AACF","sourcesContent":[".circulation-tickets {\n  border-radius: 8px;\n  background-color: #FFFFFF;\n\n  &__header {\n    display: flex;\n    padding-block: 20px;\n    align-items: center;\n\n    button {\n      width: 32px;\n      height: 32px;\n      border-radius: 6px;\n      background: #F0F0F0;\n      margin-right: 20px;\n    }\n  }\n\n  &__titles {\n    display: flex;\n    gap: 96px;\n  }\n\n  &__title {\n    display: flex;\n    gap: 4px;\n\n    span:first-child {\n      color: #999999;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 400;\n      line-height: 24px;\n    }\n    span:last-child {\n      color: #323232;\n      font-size: 20px;\n      font-style: normal;\n      font-weight: 500;\n      line-height: 24px;\n    }\n  }\n}\n\n@media only screen and (max-width: 767px) {\n  .circulation-tickets {\n    &__titles {\n      flex-direction: column;\n      gap: 16px;\n    }\n  }\n}",".circulation-tickets {\n  border-radius: 8px;\n  background-color: #FFFFFF;\n}\n\n.circulation-tickets__header {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  padding-block: 20px;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n\n.circulation-tickets__header button {\n  width: 32px;\n  height: 32px;\n  border-radius: 6px;\n  background: #F0F0F0;\n  margin-right: 20px;\n}\n\n.circulation-tickets__titles {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 96px;\n}\n\n.circulation-tickets__title {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  gap: 4px;\n}\n\n.circulation-tickets__title span:first-child {\n  color: #999999;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 24px;\n}\n\n.circulation-tickets__title span:last-child {\n  color: #323232;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 24px;\n}\n\n@media only screen and (max-width: 767px) {\n  .circulation-tickets__titles {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n        -ms-flex-direction: column;\n            flex-direction: column;\n    gap: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
